import { render, staticRenderFns } from "./LinkText.vue?vue&type=template&id=570f091a&"
import script from "./LinkText.vue?vue&type=script&lang=ts&"
export * from "./LinkText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports